import React from 'react';
import { useSelector } from 'react-redux';
import { useParams, Redirect } from 'react-router-dom';
import { formatResultsRoute } from '../../../../features/divestitureDiagnostic/routes';

import { getDivestitureDiagnosticResults } from '../../../../features/divestitureDiagnostic/divestitureDiagnosticSlice';

const RedirectIfDivestitureResults = () => {
  const { projectId } = useParams();
  const divestitureDiagnosticResults = useSelector(
    getDivestitureDiagnosticResults
  );

  return (
    divestitureDiagnosticResults && (
      <Redirect to={formatResultsRoute(projectId)} />
    )
  );
};

export default RedirectIfDivestitureResults;
